
export const FETCH_CALCULATION_PARAMETER_REQUEST = "FETCH_CALCULATION_PARAMETER_REQUEST";
export const FETCH_CALCULATION_PARAMETER_RESPONSE = "FETCH_CALCULATION_PARAMETER_RESPONSE";
export const FETCH_CALCULATE_REVENUE_REQUEST = "FETCH_CALCULATE_REVENUE_REQUEST";
export const FETCH_CALCULATE_REVENUE_RESPONSE = "FETCH_CALCULATE_REVENUE_RESPONSE";

export const fetchCalculationParameterRequest = (data) => {
    return {
        type: FETCH_CALCULATION_PARAMETER_REQUEST,
        data
    }
}

export const fetchCalculationParameterResponse = (data) => {
    return {
        type: FETCH_CALCULATION_PARAMETER_RESPONSE,
        data
    }
}

export const fetchCalculateRevenueRequest = (data) => {
    return {
        type: FETCH_CALCULATE_REVENUE_REQUEST,
        data
    }
}

export const fetchCalculateRevenueResponse = (data) => {
    return {
        type: FETCH_CALCULATE_REVENUE_RESPONSE,
        data
    }
}